export default __webpack_public_path__ + "static/messina-1-0817fe822481f4c760e1d08a98bd94a9.svg";